/**
 * 替换掉旧对象(在旧对象为不可变时替换)
 * @param {被覆盖的旧对象} oldObj
 * @param {去覆盖的新对象} newObj
 */
export const coverageObject = function (oldObj, newObj) {
    if (!getDataType(oldObj)) {
        throw String('被覆盖的变量非对象或数组')
    }
    if (!getDataType(newObj)) {
        throw String('新覆盖结果变量非对象或数组')
    }
    if (getDataType(newObj) !== getDataType(oldObj)) {
        throw String('新旧变量必须都为对象或都为数组')
    }
    if (getDataType(oldObj) === 'Array') {
        oldObj.splice(0, oldObj.length) // 清空数组
        // 拷贝数组
        newObj.forEach(function (element) {
            oldObj.push(element)
        })
    } else {
        // 清空属性字段
        for (let key in oldObj) {
            delete oldObj[key]
        }
        // 拷贝对象
        for (let key in newObj) {
            if (getDataType(newObj[key]) === 'Object') {
                oldObj[key] = coverageObject({}, newObj[key])
            } else if (getDataType(newObj[key]) === 'Array') {
                oldObj[key] = coverageObject([], newObj[key])
            } else {
                oldObj[key] = newObj[key]
            }
        }
    }
    return oldObj
}

/**
 * 判断变量是不是对象
 * @param {待判断的变量} obj
 **/
const getDataType = function (obj) {
    if (obj instanceof Array) {
        return 'Array'
    } else if (obj instanceof Object) {
        return 'Object'
    } else {
        return false
    }
}

/**
 * 清空空字符条件
 * @param {*} conditions
 */
export const copySearchConditions = function (conditions) {
    let search = Object.assign({}, conditions)
    for (let key in search) {
        if (search[key] === undefined) {
            delete search[key]
        }
        if (String(search[key]).length === 0 || (typeof search[key] === 'number' && search[key] <= 0)) {
            delete search[key]
        }
    }
    return search
}

/**
 * 只保留数组内字段,返回新对象
 * @param {*} waitObj
 * @param {*} copyObj
 */
export const cleanRedundancyField = function (waitObj, fileds) {
    if (getDataType(waitObj) !== 'Object') {
        throw String('必须为变量')
    }
    if (getDataType(fileds) !== 'Array') {
        throw String('必须为字符串数组')
    }
    let newObj = {}
    for (let key in waitObj) {
        if (fileds.indexOf(key) >= 0) {
            newObj[key] = waitObj[key]
        }
    }
    return newObj
}

/**
 * 清理数组内字段,返回新对象
 * @param {*} waitObj
 * @param {*} copyObj
 */
export const cleanHasFields = function (waitObj, fileds) {
    if (getDataType(waitObj) !== 'Object') {
        throw String('必须为变量')
    }
    if (getDataType(fileds) !== 'Array') {
        throw String('必须为字符串数组')
    }
    let newObj = {}
    for (let key in waitObj) {
        if (fileds.indexOf(key) < 0) {
            newObj[key] = waitObj[key]
        }
    }
    return newObj
}

/**
 * 拷贝已有字段
 * @param {*} waitObj
 * @param {*} copyObj
 */
export const copyHasFields = function (waitObj, copyObj) {
    if (
        getDataType(waitObj) === 'Object' &&
        getDataType(waitObj) !== getDataType(copyObj)
    ) {
        throw String('新旧变量必须都为对象')
    }
    for (let key in waitObj) {
        if (typeof copyObj[key] !== 'undefined') {
            waitObj[key] = copyObj[key]
        }
    }
    return waitObj
}

/**
 * UUID生成器
 */
export const generateUUID = function () {
    let d = new Date().getTime()
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
}
// 数组对象去重
export const arrayUnique = function (arr, name) {
    var hash = {};
    return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
        return item;
    }, []);
}
// 数组深拷贝
export const deepcopy = function (obj) {
    var out = [],
        i = 0,
        len = obj.length;
    for (; i < len; i++) {
        if (obj[i] instanceof Array) {
            out[i] = deepcopy(obj[i]);
        } else out[i] = obj[i];
    }
    return out;
}

// 判断中英文
export const isChinese = function (str) {
    const reg = /^[A-Za-z]+/
    return str?reg.test(str):false;
}

//搜索时间限制

export const fileterStartTime = function (star, end) {
    let _star = star
    return {
        disabledDate(_star) {
            if (end) {
                return new Date(end).getTime() <= _star.getTime()
            }
        }
    }
}
export const fileterEndTime = function (star, end) {
    let _end = end
    return {
        disabledDate(_end) {
            if (star) {
                return _end.getTime() < new Date(star).getTime() - 60*60*24*1000
            }
        }
    }
}

//数组对象去重
export const arrRepat = function (arr, str) {
    let obj = {}
    let noRepeat = []
    noRepeat = arr.reduce((cur, next) => {
        obj[next[str]] ? "" : obj[next[str]] = true && cur.push(next);
        return cur;
    }, [])
    return noRepeat
}
// 数字转换成大写
export const toChinesNum = (num) => {
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
            newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
        }
        return newNum;
    }
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    
}
//数组批量删除
export const arrDelete = function (arr1,arr2, str) {
    // arr1原数组
    let result = arr1.filter(function (item1) {
        return arr2.every(function (item2) {
            return item2[str] !== item1[str]
        })
    })
    return result
}
export default {
    coverageObject,
    copySearchConditions,
    copyHasFields,
    cleanRedundancyField,
    cleanHasFields,
    arrayUnique,
    deepcopy,
    isChinese,
    fileterStartTime,
    fileterEndTime,
    arrRepat,
    toChinesNum,
    arrDelete
}



// WEBPACK FOOTER //
// ./src/utils/assist.js